const initialState = {
  data: [],
};

const tablicaPrzelewyPelneReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_TABLICA_PRZELEWY_PELNE':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default tablicaPrzelewyPelneReducer;